module.exports = __webpack_public_path__ + "static/media/Login_Icon.9445d487.png";